const externalRoutes = {
    privacyPolicy: 'https://prescryptive.com/privacy-policy/',
    termsConditions: 'https://prescryptive.com/terms-of-use/',
};

export default externalRoutes;
